import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    driverSize(filter: $filter)
}`;